/* Soyamigo Mayoreo — lógica de pedido por caja */
(function () {
  'use strict';
  var cfg = window.SoyamigoMayoreo || {};
  var MIN = cfg.minimo || 500000;

  function pesos(centavos) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency', currency: 'MXN', maximumFractionDigits: 0
    }).format(centavos / 100);
  }

  function pesos2(centavos) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency', currency: 'MXN', minimumFractionDigits: 2
    }).format(centavos / 100);
  }

  /* ---------- estado del carrito ---------- */
  var carrito = null;

  function traerCarrito() {
    return fetch(cfg.rutas.carrito, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; pintar(); return c; });
  }

  function cantidadDe(idVariante) {
    if (!carrito) return 0;
    var n = 0;
    carrito.items.forEach(function (i) { if (i.variant_id === idVariante) n = i.quantity; });
    return n;
  }

  /* ---------- barra fija: se vuelve a renderizar en el servidor ---------- */
  function refrescarBarra() {
    return fetch(location.pathname + '?section_id=barra-pedido', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('#barra-pedido-raiz');
        var actual = document.querySelector('#barra-pedido-raiz');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
      })
      .catch(function () { /* si falla, la barra se queda con el último estado */ });
  }

  function pintar() {
    var cajas = carrito ? carrito.item_count : 0;
    document.querySelectorAll('[data-cuenta]').forEach(function (el) {
      el.textContent = cajas;
      var caja = el.closest('.cuenta-carrito');
      if (caja) caja.classList.toggle('con-items', cajas > 0);
    });
    pintarEstadoTarjetas();
    refrescarBarra();
  }

  /* refleja en cada tarjeta/fila cuántas cajas hay en el carrito */
  function pintarEstadoTarjetas() {
    document.querySelectorAll('[data-variante]').forEach(function (el) {
      var id = parseInt(el.dataset.variante, 10);
      var n = cantidadDe(id);
      var input = el.querySelector('[data-cant]');
      if (input && document.activeElement !== input) input.value = n;
      var menos = el.querySelector('[data-menos]');
      if (menos) menos.disabled = n === 0;
      el.classList.toggle('activa', n > 0);
      var nota = el.querySelector('[data-nota]');
      if (nota) {
        var precio = parseInt(el.dataset.precio, 10) || 0;
        nota.textContent = n > 0
          ? n + ' ' + (n === 1 ? cfg.textos.caja : cfg.textos.cajas) + ' · ' + pesos2(n * precio)
          : nota.dataset.vacio || '';
      }
    });
  }

  /* ---------- mutaciones ---------- */
  var enVuelo = false;

  function fijarCantidad(idVariante, cantidad) {
    if (enVuelo) return;
    enVuelo = true;
    document.body.classList.add('cargando');

    var yaEsta = carrito && carrito.items.some(function (i) { return i.variant_id === idVariante; });
    var url, cuerpo;

    if (yaEsta) {
      url = cfg.rutas.cambiar;
      cuerpo = { id: String(idVariante), quantity: cantidad };
    } else {
      url = cfg.rutas.agregar;
      cuerpo = { items: [{ id: idVariante, quantity: cantidad }] };
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return traerCarrito(); })
      .catch(function (e) { console.error('Soyamigo Mayoreo:', e); })
      .then(function () {
        enVuelo = false;
        document.body.classList.remove('cargando');
        if (document.body.classList.contains('plantilla-cart')) window.location.reload();
      });
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var mas = e.target.closest('[data-mas]');
    var menos = e.target.closest('[data-menos]');
    if (!mas && !menos) return;

    var caja = e.target.closest('[data-variante]');
    if (!caja) return;
    e.preventDefault();

    var id = parseInt(caja.dataset.variante, 10);
    var actual = cantidadDe(id);
    fijarCantidad(id, Math.max(0, actual + (mas ? 1 : -1)));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cant]');
    if (!input) return;
    var caja = input.closest('[data-variante]');
    if (!caja) return;
    var n = Math.max(0, Math.min(999, parseInt(input.value, 10) || 0));
    fijarCantidad(parseInt(caja.dataset.variante, 10), n);
  });

  /* botón agregar de la página de producto */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-form-producto]');
    if (!form) return;
    e.preventDefault();
    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var n = parseInt(form.querySelector('[data-cant]').value, 10) || 1;
    fijarCantidad(id, cantidadDe(id) + n);
  });

  /* alternar vista tarjetas / lista */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vista]');
    if (!b) return;
    document.querySelectorAll('[data-vista]').forEach(function (x) {
      x.setAttribute('aria-pressed', 'false');
    });
    b.setAttribute('aria-pressed', 'true');
    var lista = b.dataset.vista === 'lista';
    document.body.classList.toggle('vista-lista', lista);
    try { localStorage.setItem('soyamigo-vista', b.dataset.vista); } catch (err) {}
  });

  /* bloqueo del checkout en el carrito */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-checkout]');
    if (!btn) return;
    if (carrito && carrito.total_price < MIN) {
      e.preventDefault();
      var aviso = document.getElementById('aviso-minimo');
      if (aviso) {
        aviso.classList.remove('oculto');
        aviso.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });

  /* galería de producto */
  document.addEventListener('click', function (e) {
    var mini = e.target.closest('[data-mini]');
    if (!mini) return;
    var grande = document.getElementById('producto-media');
    if (grande) grande.src = mini.dataset.mini;
  });

  window.SoyamigoRefrescarCarrito = traerCarrito;

  /* arranque */
  document.addEventListener('DOMContentLoaded', function () {
    try {
      if (localStorage.getItem('soyamigo-vista') === 'lista' && window.innerWidth > 900) {
        document.body.classList.add('vista-lista');
        var b = document.querySelector('[data-vista="lista"]');
        if (b) {
          document.querySelectorAll('[data-vista]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
        }
      }
    } catch (err) {}
    traerCarrito();
  });
})();





/* filtros de marca de la sección Catálogo */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-marca]');
    if (!b || b.tagName !== 'BUTTON') return;
    var barra = b.closest('.cat-barra');
    var seccion = b.closest('section');
    if (!barra || !seccion) return;

    barra.querySelectorAll('[data-marca]').forEach(function (x) {
      x.setAttribute('aria-pressed', 'false');
    });
    b.setAttribute('aria-pressed', 'true');

    var marca = b.dataset.marca;
    seccion.querySelectorAll('.filtrable').forEach(function (el) {
      var coincide = marca === 'todos' || el.dataset.marca === marca;
      el.style.display = coincide ? '' : 'none';
    });
  });
})();


/* ---------- buscador predictivo ---------- */
(function () {
  var cfg = window.SoyamigoMayoreo || {};
  var caja, btn, input, panel, temporizador, ultimaConsulta = '';

  function pesos(valor) {
    var n = parseFloat(valor);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('es-MX', {
      style: 'currency', currency: 'MXN', minimumFractionDigits: 2
    }).format(n);
  }

  function abrirPanel() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
  function cerrarPanel() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }

  function estado(texto) {
    panel.innerHTML = '<p class="sug--estado">' + texto + '</p>';
    abrirPanel();
  }

  function pintar(productos, consulta) {
    if (!productos.length) {
      estado('No encontramos productos para “' + consulta.replace(/[<>]/g, '') + '”.');
      return;
    }
    var html = productos.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var sku = (p.variants && p.variants[0] && p.variants[0].sku) ? 'SKU ' + p.variants[0].sku : '';
      return '<a class="sug" href="' + p.url + '" role="option">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<span class="sug__txt"><strong>' + p.title + '</strong><span>' + sku + '</span></span>' +
        '<span class="sug__precio">' + pesos(p.price) + '</span>' +
        '</a>';
    }).join('');
    html += '<a class="sug--todos" href="' + cfg.rutas.buscar + '?q=' + encodeURIComponent(consulta) + '">' +
            'Ver todos los resultados</a>';
    panel.innerHTML = html;
    abrirPanel();
  }

  function consultar(q) {
    if (q === ultimaConsulta) return;
    ultimaConsulta = q;
    estado('Buscando…');
    var url = cfg.rutas.sugerir + '?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (input.value.trim() !== q) return;
        var lista = (d.resources && d.resources.results && d.resources.results.products) || [];
        pintar(lista, q);
      })
      .catch(function () { estado('No pudimos completar la búsqueda. Intenta de nuevo.'); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    caja = document.getElementById('buscador');
    btn = document.getElementById('buscador-btn');
    input = document.getElementById('buscador-input');
    panel = document.getElementById('buscador-panel');
    if (!caja || !btn || !input || !panel) return;

    btn.addEventListener('click', function () {
      var abierto = caja.classList.toggle('abierto');
      btn.setAttribute('aria-expanded', abierto);
      if (abierto) { input.focus(); }
      else { input.value = ''; ultimaConsulta = ''; cerrarPanel(); }
    });

    /* resultados mientras se escribe */
    input.addEventListener('input', function () {
      clearTimeout(temporizador);
      var q = input.value.trim();
      if (q.length < 2) { ultimaConsulta = ''; cerrarPanel(); return; }
      temporizador = setTimeout(function () { consultar(q); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        cerrarPanel();
        caja.classList.remove('abierto');
        btn.setAttribute('aria-expanded', 'false');
        input.value = '';
        ultimaConsulta = '';
        input.blur();
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var opciones = Array.prototype.slice.call(panel.querySelectorAll('.sug'));
        if (!opciones.length) return;
        e.preventDefault();
        var i = opciones.findIndex(function (o) { return o.classList.contains('activa'); });
        opciones.forEach(function (o) { o.classList.remove('activa'); });
        i = e.key === 'ArrowDown' ? (i + 1) % opciones.length : (i <= 0 ? opciones.length - 1 : i - 1);
        opciones[i].classList.add('activa');
        opciones[i].scrollIntoView({ block: 'nearest' });
      }
      if (e.key === 'Enter') {
        var activa = panel.querySelector('.sug.activa');
        if (activa) { e.preventDefault(); window.location.href = activa.href; }
      }
    });

    document.addEventListener('click', function (e) {
      if (!caja.contains(e.target)) cerrarPanel();
    });
  });
})();

/* ---------- carrito: vaciar y quitar línea ---------- */
(function () {
  var cfg = window.SoyamigoMayoreo || {};

  document.addEventListener('click', function (e) {
    var vaciar = e.target.closest('[data-vaciar]');
    if (vaciar) {
      if (!window.confirm('¿Quitar todos los productos de tu pedido?')) return;
      fetch(cfg.rutas.vaciar, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () { window.location.reload(); });
      return;
    }

    var quitar = e.target.closest('[data-quitar]');
    if (quitar) {
      var fila = quitar.closest('[data-variante]');
      if (!fila) return;
      var input = fila.querySelector('[data-cant]');
      if (input) { input.value = 0; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  });
})();


/* ---------- menú móvil ---------- */
(function () {
  var cfg = window.SoyamigoMayoreo || {};
  var btn, panel, input, resultados, temporizador;

  function pesos(valor) {
    var n = parseFloat(valor);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(n);
  }

  document.addEventListener('DOMContentLoaded', function () {
    btn = document.getElementById('menu-btn');
    panel = document.getElementById('menu-movil');
    input = document.getElementById('buscador-movil-input');
    resultados = document.getElementById('buscador-movil-panel');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var abierto = panel.hasAttribute('hidden');
      if (abierto) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', abierto);
      document.body.classList.toggle('menu-abierto', abierto);
    });

    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-abierto');
      });
    });

    if (!input || !resultados) return;
    input.addEventListener('input', function () {
      clearTimeout(temporizador);
      var q = input.value.trim();
      if (q.length < 2) { resultados.setAttribute('hidden', ''); return; }
      temporizador = setTimeout(function () {
        fetch(cfg.rutas.sugerir + '?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (input.value.trim() !== q) return;
            var lista = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!lista.length) {
              resultados.innerHTML = '<p class="sug--estado">Sin resultados</p>';
            } else {
              resultados.innerHTML = lista.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
                return '<a class="sug" href="' + p.url + '">' +
                  (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                  '<span class="sug__txt"><strong>' + p.title + '</strong></span>' +
                  '<span class="sug__precio">' + pesos(p.price) + '</span></a>';
              }).join('');
            }
            resultados.removeAttribute('hidden');
          })
          .catch(function () { resultados.setAttribute('hidden', ''); });
      }, 220);
    });
  });
})();

/* ---------- paquete mixto ---------- */
(function () {
  var cfg = window.SoyamigoMayoreo || {};

  function iniciar(raiz) {
    var objetivo = parseInt(raiz.dataset.objetivo, 10) || 24;
    var variante = parseInt(raiz.dataset.variante, 10);
    var sabores = Array.prototype.slice.call(raiz.querySelectorAll('[data-sabor]'));
    var elTotal = raiz.querySelector('[data-mixto-total]');
    var elRiel = raiz.querySelector('[data-mixto-riel]');
    var elEstado = raiz.querySelector('[data-mixto-estado]');
    var elLista = raiz.querySelector('[data-mixto-lista]');
    var btnAgregar = raiz.querySelector('[data-mixto-agregar]');
    var btnLimpiar = raiz.querySelector('[data-mixto-limpiar]');

    function leer() {
      var m = [], total = 0;
      sabores.forEach(function (s) {
        var n = parseInt(s.querySelector('[data-sabor-cant]').value, 10) || 0;
        if (n > 0) m.push({ nombre: s.dataset.sabor, n: n });
        total += n;
      });
      return { mezcla: m, total: total };
    }

    function pintar() {
      var d = leer();
      var restan = objetivo - d.total;

      elTotal.textContent = d.total;
      elRiel.style.width = Math.min(100, (d.total / objetivo) * 100) + '%';
      elRiel.classList.toggle('completo', d.total === objetivo);

      if (d.total === objetivo) {
        elEstado.textContent = 'Mezcla completa';
        elEstado.className = 'mixto__estado ok';
        btnAgregar.disabled = false;
      } else if (restan > 0) {
        elEstado.textContent = 'Te faltan ' + restan + ' piezas';
        elEstado.className = 'mixto__estado';
        btnAgregar.disabled = true;
      } else {
        elEstado.textContent = 'Te pasaste por ' + Math.abs(restan) + ' piezas';
        elEstado.className = 'mixto__estado error';
        btnAgregar.disabled = true;
      }

      elLista.innerHTML = d.mezcla.length
        ? d.mezcla.map(function (x) { return '<li><span>' + x.nombre + '</span><b>' + x.n + '</b></li>'; }).join('')
        : '<li class="vacio">Todavía no eliges sabores</li>';

      sabores.forEach(function (s) {
        var n = parseInt(s.querySelector('[data-sabor-cant]').value, 10) || 0;
        s.querySelector('[data-sabor-menos]').disabled = n === 0;
        s.classList.toggle('activo', n > 0);
        var mas = s.querySelector('[data-sabor-mas]');
        mas.disabled = d.total >= objetivo;
      });
    }

    raiz.addEventListener('click', function (e) {
      var mas = e.target.closest('[data-sabor-mas]');
      var menos = e.target.closest('[data-sabor-menos]');
      if (!mas && !menos) return;
      var s = e.target.closest('[data-sabor]');
      var input = s.querySelector('[data-sabor-cant]');
      var n = parseInt(input.value, 10) || 0;
      var d = leer();
      if (mas && d.total >= objetivo) return;
      input.value = Math.max(0, n + (mas ? 1 : -1));
      pintar();
    });

    raiz.addEventListener('change', function (e) {
      var input = e.target.closest('[data-sabor-cant]');
      if (!input) return;
      input.value = Math.max(0, Math.min(objetivo, parseInt(input.value, 10) || 0));
      pintar();
    });

    btnLimpiar.addEventListener('click', function () {
      sabores.forEach(function (s) { s.querySelector('[data-sabor-cant]').value = 0; });
      pintar();
    });

    btnAgregar.addEventListener('click', function () {
      var d = leer();
      if (d.total !== objetivo) return;
      var resumen = d.mezcla.map(function (x) { return x.nombre + ' ×' + x.n; }).join(', ');

      btnAgregar.disabled = true;
      btnAgregar.textContent = 'Agregando…';

      fetch(cfg.rutas.agregar, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variante, quantity: 1, properties: { 'Mezcla': resumen } }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btnAgregar.textContent = 'Agregada a tu pedido';
          sabores.forEach(function (s) { s.querySelector('[data-sabor-cant]').value = 0; });
          setTimeout(function () {
            btnAgregar.textContent = 'Agregar caja mixta';
            pintar();
          }, 1800);
          if (window.SoyamigoRefrescarCarrito) window.SoyamigoRefrescarCarrito();
        })
        .catch(function () {
          btnAgregar.textContent = 'No se pudo agregar';
          setTimeout(function () { btnAgregar.textContent = 'Agregar caja mixta'; pintar(); }, 2000);
        });
    });

    pintar();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mixto]').forEach(iniciar);
  });
})();
